export const ERROR_MESSAGE_CLASS = 'ant-form-item-has-error'
export const GA_SCRIPT_CLASS = 'google-tag-manager'
export const INSTANA_SCRIPT_CLASS = 'instana'
